import React from 'react';

import css from './hello-text.module.scss';

interface Props {
  ref: React.Ref<HTMLDivElement | null>;
}
export const HelloText: React.FC<Props> = ({ ref }) => {
  return (
    // @ts-ignore
    <div className={css.helloText} ref={ref}>
      <p>עצור לרגע,</p>
      <p>בורא עולם נמצא כאן איתך ממש</p>
      <p>בתוך הנשימה שלך</p>
      <p className={css.highlight}>הנח את האגודל על האור</p>
    </div>
  );
};
